(function(){
  var root=document.getElementById('chx');
  var scroll=document.getElementById('chxScroll');
  var gal=document.getElementById('chxGal'), plate=document.getElementById('chxPlate');
  var gal2=document.getElementById('chxGal2'), plate2=document.getElementById('chxPlate2');
  var car=document.getElementById('chxCar'), ticks=document.getElementById('chxTicks');
  var bot=document.querySelector('.chx-bot');
  var side=document.querySelector('.chx-side')||bot;
  if(!root||!scroll||!car||!bot) return;
  var slides=[].slice.call(car.querySelectorAll('.chx-slide'));
  var AR=4/5, ci=0;

  function isWide(){ return window.matchMedia('(min-width:1000px)').matches; }

  /* ----------------------------------------------------------
     Rahmen einpassen. Die Seiten rasten beim Scrollen ein - jede
     Aenderung der Hoehe laesst den Browser neu einrasten. Deshalb
     wird nur geschrieben, wenn sich der Wert geaendert hat.
  ---------------------------------------------------------- */
  function previewBarHeight(){
    var ids=['preview-bar-iframe','admin-bar-iframe'];
    for(var i=0;i<ids.length;i++){
      var el=document.getElementById(ids[i]);
      if(el && el.offsetHeight) return el.offsetHeight;
    }
    return 0;
  }
  function firstOwnY(from){
    var x=Math.round(window.innerWidth/2);
    var start=Math.max(0,Math.round(from));
    for(var y=start;y<start+220;y+=2){
      var el=document.elementFromPoint(x,y);
      if(el && root.contains(el)) return y;
    }
    return start;
  }
  function viewH(){
    return (window.visualViewport && window.visualViewport.height) || window.innerHeight;
  }
  var lastH=0, lastBot='', overSet=false;
  function measureOver(){
    root.style.marginTop='0px';
    var rTop=root.getBoundingClientRect().top;
    var o=firstOwnY(rTop)-rTop;
    if(o<0) o=0;
    if(o>200) o=200;
    root.style.marginTop=Math.round(o)+'px';
    overSet=true;
  }
  function fit(probe){
    if(probe || !overSet) measureOver();
    var top=root.getBoundingClientRect().top;
    var avail=Math.round(viewH()-top-previewBarHeight());
    if(avail<320) avail=320;
    if(avail!==lastH){ root.style.height=avail+'px'; lastH=avail; }
    var bh=Math.ceil(side.getBoundingClientRect().height);
    var want=isWide() ? '0px' : bh+'px';
    if(want!==lastBot){ root.style.setProperty('--botH',want); lastBot=want; }
  }

  /* ----------------------------------------------------------
     Menueschublade
  ---------------------------------------------------------- */
  var burger=document.getElementById('chxBurger');
  var drawer=document.getElementById('chxDrawer');
  function drListsClose(){
    if(!drawer) return;
    [].slice.call(drawer.querySelectorAll('li.has-dd.is-open')).forEach(function(li){
      li.classList.remove('is-open');
      var d=li.querySelector('.dd'); if(d) d.hidden=true;
      var t=li.querySelector('.dd-t'); if(t) t.setAttribute('aria-expanded','false');
    });
  }
  function drKey(e){ if(e.key==='Escape'||e.keyCode===27) drClose(); }
  function drOpen(){
    if(!drawer) return;
    seClose();
    drawer.hidden=false;
    requestAnimationFrame(function(){ drawer.classList.add('is-open'); });
    if(burger){ burger.setAttribute('aria-expanded','true'); burger.classList.add('is-x'); }
    document.addEventListener('keydown',drKey);
  }
  function drClose(){
    if(!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    if(burger){ burger.setAttribute('aria-expanded','false'); burger.classList.remove('is-x'); }
    setTimeout(function(){ drawer.hidden=true; drListsClose(); },280);
    document.removeEventListener('keydown',drKey);
  }
  if(burger) burger.addEventListener('click',function(e){
    e.preventDefault();
    if(drawer && drawer.hidden) drOpen(); else drClose();
  });
  if(drawer) drawer.addEventListener('click',function(e){
    if(!e.target.closest) return;
    var t=e.target.closest('.dd-t');
    if(!t) return;
    var li=t.parentElement;
    var wasOpen=li.classList.contains('is-open');
    drListsClose();
    if(!wasOpen){
      li.classList.add('is-open');
      var d=li.querySelector('.dd');
      if(d){ d.hidden=false; }
      t.setAttribute('aria-expanded','true');
    }
  });

  /* ----------------------------------------------------------
     Suche - kleines Feld unter der Kopfleiste statt eigener Seite
  ---------------------------------------------------------- */
  var seBtn=document.getElementById('chxSearchBtn');
  var seBox=document.getElementById('chxSearch');
  var seInp=document.getElementById('chxSearchInput');
  function seClose(){
    if(!seBox || seBox.hidden) return;
    seBox.hidden=true;
    if(seBtn) seBtn.setAttribute('aria-expanded','false');
  }
  function seOpen(){
    if(!seBox) return;
    ddCloseAll(null);
    seBox.hidden=false;
    if(seBtn) seBtn.setAttribute('aria-expanded','true');
    if(seInp) setTimeout(function(){ try{ seInp.focus(); seInp.select(); }catch(e){} },30);
  }

  /* ----------------------------------------------------------
     Dropdowns fuer Land und Sprache

     Die Laenderliste hat ein Suchfeld. Gefiltert wird ueber den
     sichtbaren Text der Zeile, also Landesname, Waehrungskuerzel
     und Symbol - "eur" findet damit alle Euro-Laender.
  ---------------------------------------------------------- */
  function ddFilter(dd,q){
    q=(q||'').trim().toLowerCase();
    var hit=0;
    [].slice.call(dd.querySelectorAll('li')).forEach(function(li){
      var ok = q==='' || (li.textContent||'').toLowerCase().indexOf(q)>-1;
      li.hidden=!ok;
      if(ok) hit++;
    });
    var non=dd.querySelector('.non');
    if(non) non.hidden = hit>0;
  }
  function ddCloseAll(except){
    [].slice.call(document.querySelectorAll('.chx-sel.is-open')).forEach(function(s){
      if(s===except) return;
      s.classList.remove('is-open');
      var d=s.querySelector('.chx-dd'); if(d){ d.hidden=true; d.classList.remove('is-up'); }
      var b=s.querySelector('.chx-selbtn'); if(b) b.setAttribute('aria-expanded','false');
    });
  }
  function ddToggle(btn){
    var sel=btn.closest('.chx-sel');
    var dd=sel.querySelector('.chx-dd');
    var wasOpen=sel.classList.contains('is-open');
    ddCloseAll(null);
    seClose();
    if(wasOpen || !dd) return;
    dd.hidden=false;
    dd.classList.remove('is-up');
    sel.classList.add('is-open');
    btn.setAttribute('aria-expanded','true');
    var r=dd.getBoundingClientRect();
    if(r.bottom > viewH()-8) dd.classList.add('is-up');

    var f=dd.querySelector('.chx-ddfind');
    if(f){
      f.value='';
      ddFilter(dd,'');
      /* Am Handy nicht selbst hineinspringen - sonst faehrt beim
         Oeffnen sofort die Tastatur hoch. */
      if(isWide()) setTimeout(function(){ try{ f.focus(); }catch(e){} },30);
    }
    var cur=dd.querySelector('.is-cur');
    if(cur && cur.scrollIntoView) cur.scrollIntoView({block:'nearest'});
  }
  document.addEventListener('input',function(e){
    var f=e.target.closest ? e.target.closest('.chx-ddfind') : null;
    if(!f) return;
    var dd=f.closest('.chx-dd');
    if(dd) ddFilter(dd,f.value);
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Enter' && e.keyCode!==13) return;
    var f=e.target.closest ? e.target.closest('.chx-ddfind') : null;
    if(!f) return;
    e.preventDefault();
    var dd=f.closest('.chx-dd');
    var b=dd ? dd.querySelector('li:not([hidden]) [data-code]') : null;
    if(b) b.click();
  });

  /* ----------------------------------------------------------
     Benachrichtigungs-App (STOQ und aehnliche)

     1 Alles Fremde im Kaufbereich wird ausgeblendet.
     2 Die feste Lasche am Bildschirmrand wird aus dem Bild
       geschoben - sie bleibt im Seitenbaum, damit unser
       Knopf sie anklicken und ihr Fenster oeffnen kann.
     3 Das Fenster der App selbst bleibt unangetastet.
  ---------------------------------------------------------- */
  var notifyBox=document.getElementById('chxNotify');
  var NOTIFY_SEL='[class*="stoq" i],[id*="stoq" i],'+
                 '[class*="notify" i],[id*="notify" i],'+
                 '[class*="back-in-stock" i],[id*="back-in-stock" i],'+
                 '[class*="backinstock" i],[id*="backinstock" i],'+
                 '[class*="back_in_stock" i],[id*="back_in_stock" i],'+
                 '[class*="restock" i],[id*="restock" i]';
  var ours={chxForm:1,chxVariant:1,chxAtc:1,chxNotify:1};
  var floatTrig=null;

  function keepEl(el){
    if(!el || el.nodeType!==1) return true;
    var t=el.tagName;
    if(t==='SCRIPT'||t==='STYLE'||t==='TEMPLATE'||t==='NOSCRIPT') return true;
    if(el.id && ours[el.id]) return true;
    if(el.classList.contains('chx-buytitle')) return true;
    if(el.classList.contains('up')) return true;
    if(el.classList.contains('chx-form')) return true;
    if(el.classList.contains('chx-notify')) return true;
    return false;
  }
  function notifyish(el){
    try{
      if(el.matches && el.matches(NOTIFY_SEL)) return true;
      if(el.querySelector && el.querySelector(NOTIFY_SEL)) return true;
    }catch(e){}
    return false;
  }
  function adopt(el){
    if(!notifyBox || notifyBox.contains(el)) return;
    notifyBox.appendChild(el);
    el.style.display='';
    el.removeAttribute('aria-hidden');
  }
  function cleanBuy(){
    [bot,document.getElementById('chxForm')].forEach(function(host){
      if(!host) return;
      [].slice.call(host.children).forEach(function(el){
        if(keepEl(el)) return;
        if(notifyBox && notifyBox.contains(el)) return;
        if(notifyish(el)){ adopt(el); return; }
        el.style.display='none';
        el.setAttribute('aria-hidden','true');
      });
    });
  }
  function sweepNotify(){
    if(!notifyBox || notifyBox.children.length) return;
    var list;
    try{ list=side.querySelectorAll(NOTIFY_SEL); }catch(e){ return; }
    for(var i=0;i<list.length;i++){
      var el=list[i];
      if(notifyBox.contains(el)) continue;
      if(el===notifyBox || el.contains(notifyBox)) continue;
      adopt(el);
      return;
    }
  }
  function hideFloating(){
    var list;
    try{ list=document.querySelectorAll(NOTIFY_SEL); }catch(e){ return; }
    for(var i=0;i<list.length;i++){
      var el=list[i];
      if(root.contains(el)) continue;
      if(el.getAttribute('data-chxhidden')){ if(!floatTrig) floatTrig=el; continue; }
      /* Elemente mit Eingabefeldern sind das Fenster, nicht die Lasche */
      if(el.querySelector('input,form,select,textarea')) continue;
      var cs;
      try{ cs=getComputedStyle(el); }catch(e){ continue; }
      if(cs.position!=='fixed' && cs.position!=='sticky') continue;
      el.setAttribute('data-chxhidden','1');
      el.style.setProperty('position','fixed','important');
      el.style.setProperty('left','-9999px','important');
      el.style.setProperty('top','0','important');
      el.style.setProperty('right','auto','important');
      el.style.setProperty('bottom','auto','important');
      if(!floatTrig) floatTrig=el;
    }
  }
  function notifyClick(){
    var b=notifyBox ? notifyBox.querySelector(
      'button,input[type="submit"],input[type="button"],a,[role="button"]') : null;
    if(b){ b.click(); return true; }
    if(floatTrig){
      var inner=floatTrig.querySelector('button,a,[role="button"]');
      (inner||floatTrig).click();
      return true;
    }
    return false;
  }

  slides.forEach(function(s,i){
    var b=document.createElement('button');
    b.type='button'; b.setAttribute('aria-label','Bild '+(i+1));
    b.addEventListener('click',function(){goImg(i)});
    ticks.appendChild(b);
  });

  /* Blaetterpfeile - nur am Desktop sichtbar, siehe
     cliffhanger-tune.css. An den Enden werden sie abgeschaltet. */
  var arrPrev=document.getElementById('chxPrev');
  var arrNext=document.getElementById('chxNext');
  if(arrPrev) arrPrev.addEventListener('click',function(e){
    e.preventDefault(); goImg(ci-1);
  });
  if(arrNext) arrNext.addEventListener('click',function(e){
    e.preventDefault(); goImg(ci+1);
  });

  /* Seite 1 - Breiten in ganzen Pixeln. Das Seitenverhaeltnis des
     Rahmens setzt cliffhanger-tune.css (1:1). */
  var shotW=0;
  function layout(){
    var cs=getComputedStyle(gal);
    var capH=plate.querySelector('.chx-cap').offsetHeight;
    var gap=parseFloat(getComputedStyle(plate).rowGap)||13;
    var h=gal.clientHeight-parseFloat(cs.paddingTop)-parseFloat(cs.paddingBottom)-capH-gap;
    var w=h*AR;
    var maxW=gal.clientWidth-parseFloat(cs.paddingLeft)-parseFloat(cs.paddingRight);
    if(w>maxW){ w=maxW; h=w/AR; }
    h=Math.max(120,Math.round(h)); w=Math.round(h*AR);
    shotW=w;
    plate.style.setProperty('--shotW',w+'px');
    plate.style.setProperty('--shotH',h+'px');
    sizeSlides();
  }
  function sizeSlides(){
    var w=Math.floor(car.getBoundingClientRect().width);
    if(w<40) return;
    slides.forEach(function(s){
      s.style.flex='0 0 '+w+'px';
      s.style.width=w+'px';
      s.style.scrollSnapAlign='start';
      s.style.scrollSnapStop='always';
    });
  }

  /* ----------------------------------------------------------
     Seite 2 - das Konzept-Feld wird zur Klappe

     In der Vorlage stehen Beschriftung (.chx-lead) und Feld
     (.chx-field) als zwei Geschwister. Hier werden sie beim Start
     in ein details/summary umgehaengt. Damit gehoert das Konzept
     zur selben Klappgruppe wie Design & Material und Versand -
     eines auf heisst alle anderen zu.

     Warum im Script und nicht in der Vorlage: an der Vorlage
     wird derzeit auch an anderer Stelle gearbeitet (Warenkorb-
     Schublade). Diese Umstellung braucht dort nichts anzufassen
     und ueberlebt deshalb ein Ueberschreiben der Vorlage.
  ---------------------------------------------------------- */
  (function concAcc(){
    if(!plate2) return;
    var lead=plate2.querySelector('.chx-lead');
    var fld=plate2.querySelector('.chx-field');
    if(!lead || !fld) return;
    if(lead.closest('details') || fld.closest('details')) return;

    var box=document.createElement('div');
    box.className='chx-acc chx-acc--conc';
    var det=document.createElement('details');
    det.open=true;

    /* Am Desktop bleibt das Konzept dauerhaft offen: rechts steht
       der Vertrauenskasten, der Platz ist da, und eine Klappe, die
       man ohnehin immer aufmacht, ist nur ein Klick zu viel. Die
       Markierung sagt zweierlei: die Klappgruppe unten schliesst
       sie nicht mit, und die CSS-Datei nimmt ihr den Zeiger und
       das Dreieck. Am Handy bleibt alles wie gehabt - dort zaehlt
       jede Zeile. */
    if(isWide()) det.setAttribute('data-locked','');
    var sum=document.createElement('summary');
    sum.textContent=(lead.textContent||'').trim();

    plate2.insertBefore(box,lead);
    box.appendChild(det);
    det.appendChild(sum);
    det.appendChild(fld);
    if(lead.parentNode) lead.parentNode.removeChild(lead);
  })();

  /* ----------------------------------------------------------
     Seite 2 - Beschreibungsfeld und Klappen

     Am Handy haengt unter dem Textblock der Vertrauenskasten am
     unteren Rand. Seine Hoehe wird vom verfuegbaren Platz
     abgezogen, BEVOR die Hoehe des Beschreibungsfeldes bestimmt
     wird - der Kasten haengt nicht am Feld, es gibt also keine
     Rueckkopplung zwischen beiden Werten.
  ---------------------------------------------------------- */
  function layout2(){
    if(!gal2||!plate2) return;
    var field=plate2.querySelector('.chx-field');
    if(!field) return;
    var openIn=plate2.querySelector('.chx-acc details[open] .in');
    if(openIn) openIn.style.maxHeight='none';

    var cs=getComputedStyle(gal2);
    var gap=parseFloat(getComputedStyle(plate2).rowGap)||14;

    /* Das Beschreibungsfeld steckt selbst in einer Klappbox.
       Zaehlte man diesen Zweig voll mit, ginge die Hoehe des
       Feldes in ihre eigene Berechnung ein und beide Werte
       wuerden sich gegenseitig hin- und herschieben. Vom Zweig
       des Feldes zaehlt deshalb nur, was NICHT das Feld ist -
       also die Beschriftung der Klappe. Ist die Klappe zu, ist
       die Hoehe des Feldes ohnehin null. */
    var used=0;
    [].slice.call(plate2.children).forEach(function(c){
      if(c===field) return;
      var ch=c.getBoundingClientRect().height;
      if(c.contains(field)) ch-=field.getBoundingClientRect().height;
      used+=ch+gap;
    });

    var tb=gal2.querySelector('.chx-trust--mob');
    var tbH=0;
    if(tb && tb.offsetParent!==null){
      tbH=tb.getBoundingClientRect().height+gap;
    }

    var availH=gal2.clientHeight-parseFloat(cs.paddingTop)-parseFloat(cs.paddingBottom)-tbH;
    var maxW=gal2.clientWidth-parseFloat(cs.paddingLeft)-parseFloat(cs.paddingRight);
    var w=shotW||maxW;
    if(w>maxW) w=maxW;
    var h=availH-used;
    var cap=availH*(openIn?0.30:0.52);
    if(h>cap) h=cap;
    h=Math.max(openIn?110:140,Math.round(h));
    plate2.style.setProperty('--shotW2',Math.round(w)+'px');
    plate2.style.setProperty('--shotH2',h+'px');

    if(openIn){
      var limit=gal2.getBoundingClientRect().bottom-parseFloat(cs.paddingBottom)-tbH;
      var over=plate2.getBoundingClientRect().bottom-limit;
      if(over>0){
        var cur=openIn.getBoundingClientRect().height;
        openIn.style.maxHeight=Math.max(70,Math.floor(cur-over-2))+'px';
      }
    }
  }

  /* Seite 3 - Empfehlungen */
  function cardsFit(){
    var wrap=document.querySelector('.chx-related');
    if(!wrap) return;
    var grid=wrap.querySelector('.chx-cards');
    if(!grid||!grid.children.length) return;
    wrap.style.setProperty('--imH','0px');
    wrap.style.setProperty('--imW','0px');
    var wcs=getComputedStyle(wrap);
    var gapW=parseFloat(wcs.rowGap)||14;
    var innerW=wrap.clientWidth-parseFloat(wcs.paddingLeft)-parseFloat(wcs.paddingRight);
    var H=scroll.clientHeight-parseFloat(wcs.paddingTop)-parseFloat(wcs.paddingBottom);
    [].slice.call(wrap.children).forEach(function(c){
      if(c!==grid) H-=c.getBoundingClientRect().height+gapW;
    });
    var gcs=getComputedStyle(grid);
    var cols=(gcs.gridTemplateColumns||'').split(' ').filter(Boolean).length||4;
    var colGap=parseFloat(gcs.columnGap)||14, rowGap=parseFloat(gcs.rowGap)||14;
    var vis=[].slice.call(grid.children).filter(function(c){
      return c.offsetParent!==null || c.getClientRects().length;
    }).length || grid.children.length;
    var rows2=Math.ceil(vis/cols);
    var txt=grid.children[0].getBoundingClientRect().height;
    var imH=(H-(rows2-1)*rowGap-rows2*txt)/rows2;
    var colW=grid.children[0].getBoundingClientRect().width;
    if(!(colW>10)) colW=(innerW-(cols-1)*colGap)/cols;
    /* Rahmen sind quadratisch, breiter als die Spalte geht nicht */
    if(imH>colW) imH=colW;
    if(imH<70) imH=70;
    wrap.style.setProperty('--imH',Math.floor(imH)+'px');
    cardsTrim(wrap,grid,cols,rows2);
    cardFrames(wrap);
  }
  function cardsTrim(wrap,grid,cols,rows2){
    var seg=wrap.parentElement;
    if(!seg) return;
    var cur=parseFloat(wrap.style.getPropertyValue('--imH'))||0;
    for(var k=0;k<4;k++){
      var over=wrap.getBoundingClientRect().height-seg.clientHeight;
      if(over<=2) break;
      cur=cur-Math.ceil(over/rows2)-2;
      if(cur<70){ cur=70; wrap.style.setProperty('--imH','70px'); break; }
      wrap.style.setProperty('--imH',Math.floor(cur)+'px');
    }
  }
  function cardFrames(wrap){
    var h=parseFloat(wrap.style.getPropertyValue('--imH'))||0;
    if(h<10) return;
    wrap.style.setProperty('--imW',Math.floor(h)+'px');
    [].slice.call(wrap.querySelectorAll('.chx-card .ph')).forEach(function(ph){
      var w=Math.floor(ph.getBoundingClientRect().width);
      if(w<20) return;
      [].slice.call(ph.children).forEach(function(fr){
        fr.style.flex='0 0 '+w+'px';
        fr.style.width=w+'px';
      });
      ph.scrollLeft=0;
    });
  }

  [].slice.call(document.querySelectorAll('.chx-card .ph')).forEach(function(ph){
    var card=ph.parentElement.parentElement;
    var pd=false,px=0,pl=0,pmoved=false;
    ph.addEventListener('pointerdown',function(e){
      if(e.pointerType==='touch') return;
      if(ph.scrollWidth<=ph.clientWidth+2) return;
      e.preventDefault();
      pd=true; pmoved=false; px=e.clientX; pl=ph.scrollLeft;
      try{ ph.setPointerCapture(e.pointerId); }catch(err){}
    });
    ph.addEventListener('pointermove',function(e){
      if(!pd) return;
      var d=e.clientX-px; if(Math.abs(d)>3) pmoved=true;
      ph.scrollLeft=pl-d;
    });
    function stop(){
      if(!pd) return; pd=false;
      var w=ph.clientWidth||1, delta=ph.scrollLeft-pl;
      var i=Math.round(pl/w);
      if(Math.abs(delta)>w*0.15) i+=(delta>0?1:-1);
      i=Math.max(0,Math.min(ph.children.length-1,i));
      var t=ph.children[i];
      ph.scrollTo({left:t?t.offsetLeft:i*w,behavior:'smooth'});
    }
    ph.addEventListener('pointerup',stop);
    ph.addEventListener('pointercancel',stop);
    if(card) card.addEventListener('click',function(e){
      if(pmoved){ e.preventDefault(); pmoved=false; }
    });
  });

  function relayout(){
    fit(true); layout();
    layout2(); layout2();
    cardsFit(); goImg(ci); barCheck();
  }

  function goImg(i){
    ci=Math.max(0,Math.min(slides.length-1,i));
    var t=slides[ci];
    car.scrollTo({left:t?t.offsetLeft:ci*car.clientWidth,behavior:'smooth'});
    paint();
  }
  function paint(){
    [].slice.call(ticks.children).forEach(function(b,i){
      b.setAttribute('aria-current', i===ci?'true':'false');
    });
    if(arrPrev) arrPrev.disabled = ci<=0;
    if(arrNext) arrNext.disabled = ci>=slides.length-1;
  }
  car.addEventListener('scroll',function(){
    var w=car.clientWidth; if(!w) return;
    var i=Math.round(car.scrollLeft/w);
    if(i!==ci){ ci=i; paint(); }
  },{passive:true});

  var down=false,sx=0,sl=0,moved=false;
  car.addEventListener('pointerdown',function(e){
    if(e.pointerType==='touch') return;
    e.preventDefault(); down=true; moved=false; sx=e.clientX; sl=car.scrollLeft;
    car.classList.add('is-drag'); car.setPointerCapture(e.pointerId);
  });
  car.addEventListener('pointermove',function(e){
    if(!down) return;
    var d=e.clientX-sx; if(Math.abs(d)>3) moved=true;
    car.scrollLeft=sl-d;
  });
  function endDrag(){
    if(!down) return; down=false;
    var w=car.clientWidth, delta=car.scrollLeft-sl;
    car.classList.remove('is-drag');
    if(Math.abs(delta)>w*0.12) goImg(ci+(delta>0?1:-1)); else goImg(ci);
  }
  car.addEventListener('pointerup',endDrag);
  car.addEventListener('pointercancel',endDrag);
  car.addEventListener('click',function(e){ if(moved) e.preventDefault(); });

  var segs=[].slice.call(scroll.querySelectorAll('.chx-seg'));
  var lastSeg=scroll.querySelector('.chx-seg--foot') ||
              (segs.length ? segs[segs.length-1] : null);
  var nobar=false;
  function barCheck(){
    if(!lastSeg) return;
    var sr=scroll.getBoundingClientRect();
    var r=lastSeg.getBoundingClientRect();
    var h=sr.height;
    var vis=Math.min(r.bottom,sr.bottom)-Math.max(r.top,sr.top);
    var want = h>0 && vis > h*0.55;
    if(want!==nobar){ nobar=want; root.classList.toggle('is-nobar',nobar); }
  }

  /* ----------------------------------------------------------
     Kopfleiste beim Scrollen

     Desktop: weg, sobald man die erste Seite verlaesst.
     Handy:   weg beim Runterwischen, zurueck beim Hochwischen.
  ---------------------------------------------------------- */
  var scrolling=0, lastY=0;
  function navHide(on){
    if(on===root.classList.contains('is-navhidden')) return;
    root.classList.toggle('is-navhidden',on);
    if(on) seClose();
  }
  /* Die Ankuendigungsleiste gehoert nur auf Seite 1. Sobald man
     sie verlaesst, faellt --annH im Stylesheet auf 0 und ihr
     Platzbedarf verschwindet auf allen Seiten in einem Zug.
     Weil sich damit die Innenabstaende aendern, muss danach neu
     eingepasst werden - later() wartet, bis das Scrollen ruht. */
  var annOff=false;
  function annCheck(){
    var want = scroll.scrollTop > 6;
    if(want===annOff) return;
    annOff=want;
    root.classList.toggle('is-annoff',annOff);
    later(relayout,320);
  }
  scroll.addEventListener('scroll',function(){
    scrolling=Date.now();
    var y=scroll.scrollTop, d=y-lastY;
    if(isWide()){
      navHide(y>6);
      root.classList.toggle('is-navshadow', y>6);
    } else if(y<=6){
      navHide(false); root.classList.remove('is-navshadow');
    } else {
      root.classList.add('is-navshadow');
      if(d>4) navHide(true);
      if(d<-4) navHide(false);
    }
    lastY=y;
    annCheck();
    barCheck();
  },{passive:true});
  function busyScrolling(){ return Date.now()-scrolling < 500; }

  /* ---------- Groessentabelle ---------- */
  var sg=document.getElementById('chxSg');
  function sgKey(e){ if(e.key==='Escape'||e.keyCode===27) sgClose(); }
  function sgOpen(){
    if(!sg) return;
    sg.hidden=false;
    document.addEventListener('keydown',sgKey);
    var x=sg.querySelector('.x'); if(x) x.focus();
  }
  function sgClose(){
    if(!sg) return;
    sg.hidden=true;
    document.removeEventListener('keydown',sgKey);
  }

  /* ---------- ein Klickfaenger fuer alles ---------- */
  document.addEventListener('click',function(e){
    if(!e.target.closest) return;

    if(e.target.closest('[data-sgopen]')){ e.preventDefault(); sgOpen(); return; }
    if(e.target.closest('[data-sgclose]')){ e.preventDefault(); sgClose(); return; }

    if(e.target.closest('#chxSearchBtn')){
      e.preventDefault();
      if(seBox && seBox.hidden) seOpen(); else seClose();
      return;
    }

    var sb=e.target.closest('.chx-selbtn');
    if(sb){ e.preventDefault(); ddToggle(sb); return; }

    var cd=e.target.closest('[data-code]');
    if(cd && cd.closest('.chx-dd')){
      e.preventDefault();
      var inp=document.getElementById('chxCtryCode');
      var frm=document.getElementById('chxCtryForm');
      if(inp&&frm){ inp.value=cd.getAttribute('data-code'); frm.submit(); }
      return;
    }

    if(!e.target.closest('.chx-search')) seClose();
    if(!e.target.closest('.chx-dd')) ddCloseAll(null);
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'||e.keyCode===27){ ddCloseAll(null); seClose(); }
  });

  /* ---------- Auswahl im Kaufbereich ---------- */
  var up=side.querySelector('.up');
  var hidden=document.getElementById('chxVariant');
  var atc=document.getElementById('chxAtc');
  var atcLabel=document.getElementById('chxAtcLabel');
  var atcPrice=document.getElementById('chxAtcPrice');
  var atcSep=atc?atc.querySelector('.sep'):null;
  var txtAdd=(atc&&atc.getAttribute('data-add'))||'Add to cart';
  var txtNotify=(atc&&atc.getAttribute('data-notify'))||'Get notified when size available';
  var data=null;
  try{ data=JSON.parse(document.getElementById('chxData').textContent); }catch(err){}

  function optRows(){
    return [].slice.call(up?up.querySelectorAll('.chx-optvals[data-oi]'):[]);
  }
  function currentSel(){
    var sel=[];
    optRows().forEach(function(row){
      var i=parseInt(row.getAttribute('data-oi'),10)||0;
      var b=row.querySelector('[aria-pressed="true"]')||row.querySelector('.chx-val');
      sel[i]=b?b.getAttribute('data-val'):'';
    });
    return sel;
  }
  function findVariant(sel){
    if(!data||!data.variants) return null;
    for(var i=0;i<data.variants.length;i++){
      var v=data.variants[i], ok=true;
      for(var k=0;k<sel.length;k++){
        if(sel[k]===undefined) continue;
        if(String(v.opts[k])!==sel[k]){ ok=false; break; }
      }
      if(ok) return v;
    }
    return null;
  }
  function markAvailability(){
    if(!data||!data.variants) return;
    optRows().forEach(function(row){
      var i=parseInt(row.getAttribute('data-oi'),10)||0;
      [].slice.call(row.children).forEach(function(b){
        var any=false;
        for(var j=0;j<data.variants.length;j++){
          var v=data.variants[j];
          if(String(v.opts[i])===b.getAttribute('data-val') && v.available){ any=true; break; }
        }
        b.classList.toggle('is-out',!any);
      });
    });
  }

  var lastAvail=true;
  function setState(available){
    lastAvail=available;
    if(atc){
      atc.disabled=false;
      atc.classList.toggle('is-oos',!available);
      atc.setAttribute('type', available ? 'submit' : 'button');
    }
    if(atcLabel) atcLabel.textContent = available ? txtAdd : txtNotify;
    if(atcSep) atcSep.style.display = available ? '' : 'none';
    if(atcPrice) atcPrice.style.display = available ? '' : 'none';
    bot.classList.toggle('is-notify',!available);
  }
  if(atc) atc.addEventListener('click',function(e){
    if(lastAvail) return;
    e.preventDefault();
    cleanBuy(); sweepNotify(); hideFloating();
    if(notifyClick()) return;
    var url=atc.getAttribute('data-contact');
    if(url) location.href=url;
  });

  function apply(){
    var sel=currentSel();
    if(up) [].slice.call(up.querySelectorAll('.chx-optlab .val[data-oi]')).forEach(function(el){
      var i=parseInt(el.getAttribute('data-oi'),10)||0;
      if(sel[i]) el.textContent=sel[i];
    });
    var v=findVariant(sel);
    if(v){
      if(hidden){
        hidden.value=v.id;
        try{ hidden.dispatchEvent(new Event('change',{bubbles:true})); }catch(e){}
      }
      if(atcPrice) atcPrice.textContent=v.price;
      try{ var u=new URL(location.href); u.searchParams.set('variant',v.id);
           history.replaceState({},'',u); }catch(e){}
      cleanBuy(); sweepNotify(); hideFloating();
      setState(!!v.available);
    }
    fit(false);
  }
  if(up) up.addEventListener('click',function(e){
    var b=e.target.closest('.chx-val');
    if(!b || b.tagName==='A') return;
    var row=b.parentElement;
    [].slice.call(row.children).forEach(function(x){
      x.setAttribute('aria-pressed', x===b?'true':'false');
    });
    apply();
  });
  markAvailability();
  cleanBuy(); sweepNotify(); hideFloating();
  (function(){
    var v=findVariant(currentSel());
    setState(v ? !!v.available : true);
  })();

  /* Die App laedt nach - eine Weile lang nachfassen */
  var hf=setInterval(function(){ cleanBuy(); sweepNotify(); hideFloating(); },700);
  setTimeout(function(){ clearInterval(hf); },20000);

  if(window.MutationObserver){
    var pend=false;
    var mo=new MutationObserver(function(){
      if(pend) return; pend=true;
      setTimeout(function(){
        pend=false; cleanBuy(); sweepNotify(); setState(lastAvail);
      },120);
    });
    mo.observe(bot,{childList:true,subtree:true});
    setTimeout(function(){ try{ mo.disconnect(); }catch(e){} },20000);
  }

  /* Klappen auf Seite 2: eine oeffnen schliesst alle anderen.
     Gesucht wird ueber die ganze Seite, nicht nur im eigenen
     Behaelter - das Konzept-Feld steht in einem eigenen
     .chx-acc, gehoert aber zur selben Gruppe. */
  document.addEventListener('toggle',function(e){
    var d=e.target;
    if(!d || d.tagName!=='DETAILS') return;
    if(!d.closest('.chx-acc')) return;
    if(d.open){
      [].slice.call(document.querySelectorAll('.chx-acc details')).forEach(function(o){
        if(o!==d && o.open && !o.hasAttribute('data-locked')) o.open=false;
      });
    }
    layout2(); layout2();
  },true);

  /* Klaviyo: bleibt der Baustein leer, kommt das eingebaute
     Formular zurueck. */
  setTimeout(function(){
    var k=document.getElementById('chxKlav');
    if(!k) return;
    if(k.querySelector('form,input,iframe')) return;
    var box=k.closest('.chx-foot-news');
    k.style.display='none';
    if(box) box.classList.remove('has-klav');
  },2500);

  var rt=null;
  function later(fn,ms){
    clearTimeout(rt);
    rt=setTimeout(function(){
      if(busyScrolling()){ later(fn,200); return; }
      fn();
    },ms||160);
  }
  addEventListener('resize',function(){ later(relayout) });
  addEventListener('orientationchange',function(){ later(relayout,300) });
  if(window.visualViewport){
    window.visualViewport.addEventListener('resize',function(){
      later(function(){ fit(false) },200);
    });
  }
  if(window.ResizeObserver){
    new ResizeObserver(function(){ if(!busyScrolling()) fit(false); }).observe(side);
  }
  [0,300,800,1500,3000].forEach(function(t){
    setTimeout(function(){ if(!busyScrolling()) relayout(); },t);
  });
  addEventListener('load',function(){ if(!busyScrolling()) relayout(); });

  relayout(); paint(); annCheck();
})();